import { FC } from "react"
import CareerListPage, { CareerListPageProps } from "@modules/career-list/CareerListPage"
import { GetServerSideProps, GetServerSidePropsContext } from "next"
import { Job } from "@interfaces/career"
import { ParsedUrlQuery } from "querystring"
import CategoryRepositories from "@lib/api/repositories/category.repositories"
import { PaginationData } from "@interfaces/misc"
import JobsRepositories from "@lib/api/repositories/jobs.repositories"

const CareerListDriver: FC<CareerListPageProps> = ({ categoryDetail, initialData }) =>
  CareerListPage({ categoryDetail, initialData })

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const category = new CategoryRepositories()
  const jobs = new JobsRepositories()

  const params = context.params
  const { slug } = params as ParsedUrlQuery

  try {
    const res = category.getRawCategoryDetail(slug as string)

    const res2 = jobs.getRawJobs({
      ...(params?.type && { type: params?.type as string }),
      ...(params?.search && { search: params.search as string }),
      ...(params?.slug && { category: params.slug as string }),
    })

    let categoryDetail = null
    let data: Job[] = []

    const [ctg, job] = await Promise.all([res, res2])

    if (ctg.ok) {
      const response = await ctg.json()
      categoryDetail = response.result
    }

    if (job.ok) {
      const response = await job.json()
      const result = response.result as PaginationData<Job>

      data = result.data
    }

    return {
      props: {
        categoryDetail,
        initialData: data,
      },
    }
  } catch (e: any) {
    console.log(e)

    return {
      props: {
        categoryDetail: null,
        initialData: [],
      },
    }
  }
}

export default CareerListDriver
